import React from 'react'
import { palettes } from '@manychat/manyui'

import ColorPicker from 'components/forms/ColorPicker'
import { SliceType } from 'components/MCTextEditor/slice/types'
import { Decorators } from 'components/RichTextEditor/decorators/useDecorators'

import ToolbarItem from './ToolbarItem'

const TextColorTool = ({
  decorators,
  onOpenChange,
  className = '',
}: {
  decorators: Decorators
  onOpenChange?: (isOpen: boolean) => void
  className?: string
}) => {
  const colorSliceData = decorators.getList().find((d) => d.type === SliceType.TEXT_COLOR)
    ?.data as {
    color: string
  }
  const color = colorSliceData?.color || palettes.typography.body

  const anchor = (
    <ColorPicker
      value={color}
      size={18}
      noHover={true}
      closeAfterSelect={true}
      withClearColor={true}
      disableTooltip={true}
      onOpenChange={onOpenChange}
      onChange={(name: string, color: string) => {
        if (!colorSliceData && !color) {
          return
        }
        const data = color ? { color } : undefined
        decorators.toggle({ type: SliceType.TEXT_COLOR, data })
      }}
    />
  )

  return <ToolbarItem isSelected={false} className={className} renderAnchor={() => anchor} />
}

export default TextColorTool
